import { AccountNotFoundError, } from "@alchemy/aa-core";
import {} from "viem";
import { MultisigPlugin } from "../plugin.js";
export async function isOwnerOf(client, args) {
    const account = args.account ?? client.account;
    if (!account) {
        throw new AccountNotFoundError();
    }
    const contract = MultisigPlugin.getContract(client, args.pluginAddress);
    return await contract.read.isOwnerOf([account.address, args.address]);
}
//# sourceMappingURL=isOwnerOf.js.map